import axios from '@/axios'

export default {
	namespaced: true,

	actions: {
		fetchAll({ commit }, { fromDate, toDate, type: workType, page, perPage, ownerIds, usePagination }) {
			const params = { fromDate, toDate, workType, page, perPage, usePagination };
			const urlSearchParams = new URLSearchParams();

			Object.keys(params).forEach(key => {
				if (params[key] !== null && params[key] !== undefined) urlSearchParams.append(key, params[key]);
			});

			if (Array.isArray(ownerIds)) {
				ownerIds.forEach(id => urlSearchParams.append('ownerIds', id));
			}
			urlSearchParams.append('sortByCreatedAt', true)
			urlSearchParams.append('Isposted', true)

			return axios.get('/materialJournal/filterWork', {
				params: urlSearchParams,
			})
		},

		create({ commit }, { date, workType, workItemRequests }) {
			/* workItemRequests = [
				quantity
				ownerId
				lot
				itemId
				date
				notes
			] */
			return axios.post('/materialJournal/work', { date, workType, workItemRequests })
		},

		update({ commit }, { id, date, workType, workItemRequests }) {
			/* workItemRequests = [
				quantity
				ownerId
				lot
				itemId
				date
				notes
			] */
			return axios.put(`/materialJournal/work/${id}`, { date, workType, workItemRequests })
		},

		delete({ commit }, { id }) {
			return axios.delete(`/materialJournal/work/${id}`)
		}
	},
}